/*
 * @Description: 初始化与注册子应用
 * @Date: 2021-10-19 16:43:37
 */
import store from '../store/index';
import { instance } from '@/main';

const getActiveRule = hash => location => {
  return location.hash.startsWith(hash);
};

function loader(loading) {
  if (instance && instance.$children) {
    // instance.$children[0] 是App.vue，此时直接改动App.vue的isLoading
    instance.$children[0].isLoading = loading;
  }
}

const micros = [
  {
    name: 'asp-v3',
    developer: 'xrk',
    entry: `${process.env.VUE_APP_SUBAPP_DOMAIN}${process.env.VUE_APP_SUBAPP_PATH}`, // 根据环境设置，线上与本机打包需要在.env中写死
    activeRule: getActiveRule('#/v3')
  }
];

const apps = micros.map(item => {
  return {
    ...item,
    loader, // 给子应用配置加上loader方法
    container: '#subapp-container', // 子应用挂载的div,只可有一个容器
    // qiankun会把该项merge
    props: {
      developer: item.developer, // 下发基础路由
      routerBase: item.activeRule, // 下发基础路由
      getGlobalState: store.getGlobalState // 下发getGlobalState方法。 onGlobalStateChange  setGlobalState  offGlobalStateChange 自动注入
    }
  };
});
export default apps;
